<template>
  <div class="">

    <i class="text-warning bi  modal-wrapper-icon"

       :class="orderShipmentFill"

       data-toggle="modal" :data-target="`#${orderModal}`"/>

    <!-- Modal -->
    <div class="modal fade" :id="`${orderModal}`" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="saveShipmentCode" class="form-group">


              <label v-t="`factor.order_delivery_code.shipment_code_label`"></label>
              <input
                  dir="ltr"
                  v-model="order.shipment_code"
                  type="text"
                  class="text-left form-control">

              <button type="submit"
                      v-t="`factor.order_delivery_code.submit_button`"
                      class="btn w-100 my-2 btn-success"></button>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: "OrderDeliveryCode1",
  props: {
    order: {}
  },
  computed: {
    orderModal() {
      return `order-delivery-code-${this.order.id}`
    },
    orderShipmentFill() {
      if (this.order.shipment_code != null && this.order.shipment_code.length > 0) {
        return 'bi-pencil-fill'
      }
      return 'bi-pencil'
    }
  },
  methods: {
    saveShipmentCode() {
      let form = {
        order_id: this.order.id,
        shipment_code: this.order.shipment_code,
      }
      this.$store.dispatch('ShoppingCart/updateOrderGeneralInfo', form);
      $(`#${this.orderModal}`).modal('hide');
    },

  },
}
</script>

<style scoped>

.modal-wrapper-icon {
  font-size: 25px;
  cursor: pointer;
}

</style>